import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "pdt-30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center pdb-20" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "" }, "Alerts & Notifications")
], -1)
const _hoisted_3 = { class: "filters d-flex gap-4 flex-wrap flex-md-nowrap justify-content-between w-100" }
const _hoisted_4 = { class: "d-flex gap-4 col-md-3 col-sm-12" }
const _hoisted_5 = { class: "small striped toggle no-underline" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "large" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "pdl-10 pdr-10 d-flex justify-content-between w-100" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, " Alert ID "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, " Document Type ID "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, " Fund Type "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, " Type"),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, " Message "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, " Action ")
      ])
    ])
  ])
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "6" }
const _hoisted_9 = { class: "d-flex flex-column w-100" }
const _hoisted_10 = { class: "d-flex justify-content-between flex-wrap flex-md-nowrap w-100 sm-gap-20" }
const _hoisted_11 = { class: "cell col-md-1 col-sm-5" }
const _hoisted_12 = { class: "cell col-md-2 col-sm-5 d-flex flex-wrap gap-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "bullet" }, null, -1)
const _hoisted_14 = { class: "cell col-md-1 col-sm-5" }
const _hoisted_15 = { class: "cell col-md-2 col-sm-5" }
const _hoisted_16 = { class: "cell col-md-2 col-sm-5" }
const _hoisted_17 = { class: "cell col-md-1 col-sm-5" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("tr", { class: "text-center py-5" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, " No Alert Types found ")
], -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return ($setup.loading)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
          class: "bordered-card bordered-card_secondary pdb-10",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_SelectComponent, {
                selectedOption: $setup.filters.FundType,
                "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters.FundType) = $event)),
                options: $setup.fundTypes,
                "single-arrow": true,
                customClass: "fs-xs"
              }, null, 8, ["selectedOption", "options"])
            ]),
            _createVNode(_component_TextInput, {
              name: "mixed",
              type: "text",
              placeholder: "Search by Alert",
              max: 50,
              modelValue: $setup.filters.Alert,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.Alert) = $event)),
              customClass: "search"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            ($setup.alertTypes.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alertTypes, (alertType) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: alertType.AlertTypeID,
                      class: "large"
                    }, [
                      _createElementVNode("td", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(alertType.AlertTypeID), 1),
                            _createElementVNode("div", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alertType.Documents, (doc, index) => {
                                return (_openBlock(), _createElementBlock("small", {
                                  class: _normalizeClass(["label label_small label_green_secondary w-fit", { 'label_blue': index % 2 }]),
                                  key: doc.CodeID
                                }, [
                                  _hoisted_13,
                                  _createTextVNode(" " + _toDisplayString(doc.Description), 1)
                                ], 2))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(alertType.FundType != '0' ? alertType.FundType : ''), 1),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(alertType.Name), 1),
                            _createElementVNode("div", _hoisted_16, _toDisplayString($setup.getTruncatedNotes(alertType.Message)), 1),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("i", {
                                class: "plan-modal iatse-icon-edit fs-6 fw-semibold",
                                onClick: ($event: any) => ($setup.editAlert(alertType))
                              }, null, 8, _hoisted_18)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_19, _hoisted_21))
          ])
        ], 32),
        _createVNode(_component_PaginationComponent, {
          paginator: $setup.paginator,
          onFetchData: $setup.fetchPaginationData
        }, null, 8, ["paginator", "onFetchData"])
      ]))
}